import { axiosClient } from "@/shared/api/axios-client";
import type { CargarZipResultado } from "@/features/cargar-zip/types";

export const cargarZipApi = {
  cargar: (solicitudId: string, zip: File) => {
    const form = new FormData();
    form.append("zip", zip);
    return axiosClient
      .post<CargarZipResultado>(
        `/api/solicitudes/${solicitudId}/cfdi-zip`,
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((r) => r.data);
  },
};
